const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function fmtPoDate(iso: string | null | undefined): string {
    if (!iso) return '-';
    // A bare YYYY-MM-DD parses as UTC midnight, which renders as the previous
    // day west of Greenwich - anchor those to local time instead.
    const value = DATE_ONLY.test(iso) ? `${iso}T00:00:00` : iso;
    return new Date(value).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
}
